export const ALLOWED_TYPES = ['image/png', 'image/jpeg'];
export const MIN_OUTPUT_SIZE = 300;
export const EDITOR_SIZE = 250;
